<template>
    <div class="fzg-join-detail-mobile">
      <div class="fzg-banner">
        <fzg-menu/>
        <img class="m-banner" src="../../assets/img2/mobile/join/banner.jpg" alt="">
      </div>


      <div class="fzg-job-detail">
        <div class="jd-title">
            <div class="title-text">{{ jobDetail.title }}</div>
            <!-- <a class="send-email-btn" :href="'mailto:'+jobDetail.email">投递简历</a> -->
        </div>
        <div class="jd-desc">
          <div class="type-title">【岗位职责】</div>
          <div class="jd-content"> {{ jobDetail.jd }} </div>
        </div>
        <div class="jd-requirement">
          <div class="type-title">【职位要求】</div>
          <div class="jd-content"> {{ jobDetail.requirement }} </div>
        </div>
      </div>


      <div v-if="false" class="fzg-job-detail">
        <div class="jd-title">
            <div class="title-text">凡卓集团-凡卓资本-分析师/高级分析师</div>
            <a class="send-email-btn" href="mailto:hr@xfz.cn">投递简历</a>
        </div>
        <div class="jd-desc">
          <div class="type-title">【岗位职责】</div>
          <div class="jd-content">
            <ul>
              <li> 在融资项目协作中提供PPT/图表制作支持、强逻辑梳理、快速响应； </li>
              <li> 根据公司确定的投资方向，开展市场及行业研究，深入了解行业现状，分析梳理产业链，撰写行业分析报告；</li>
              <li> 寻找优秀创业者及创业团队，与之建立良好的沟通及合作关系；</li>
              <li> 辅助创业团队梳理商业模式建议及融资方案；</li>
              <li> 把控项目中可能出现的风险，促成交易圆满，提升项目成交率。</li>
            </ul>
          </div>
        </div>
        <div class="jd-requirement">
          <div class="type-title">【职位要求】</div>
          <div class="jd-content">
            <ul>
              <li> 在融资项目协作中提供PPT/图表制作支持、强逻辑梳理、快速响应； </li>
              <li> 根据公司确定的投资方向，开展市场及行业研究，深入了解行业现状，分析梳理产业链，撰写行业分析报告；</li>
              <li> 寻找优秀创业者及创业团队，与之建立良好的沟通及合作关系；</li>
              <li> 辅助创业团队梳理商业模式建议及融资方案；</li>
              <li> 把控项目中可能出现的风险，促成交易圆满，提升项目成交率。</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenuMobile.vue'

export default{
    components:{
      FzgMenu
    },
    props:[''],
    data(){
      return {
        jobDetail: {},
      }
    },
    methods:{

      getJobDetail() {
        var id = this.$route.query.id
        if (!id) {
          console.log('id错误')
          return
        }
        var self = this
        util.resource({
            url: '/api/fzg/job_detail/',
            method: 'get',
            data: {
              id: id
            },
            success (res) {
              if (res.code == 200) {
                self.jobDetail = res.data
              }
            }
        })
      },
    },
    mounted(){
      this.getJobDetail()
    },
    watch: {
      // '$route' (to, from) {
      //   this.getJobDetail()
      // }
    },

}
</script>

<style lang="scss" scoped>
.fzg-join-detail-mobile {
  .fzg-banner {
    // border: 1px solid red;
    // background-color: #8799b1;
    position: relative;
    .m-banner {
      width: 100%;
    }
  }

  .fzg-job-detail {
    width: 100%;
    margin: 0 auto;
    padding: 20px;
    .jd-title{
      color: white;
      background: #d7ad78;
      position: relative;
      margin-top: 10px;
      .title-text {
        font-size: 15px;
        padding: 10px 20px;
      }
      .send-email-btn {
        width: 140px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: white;
        position: absolute;
        right: 0;
        top: 0;
        margin: 15px 40px;
        cursor: pointer;
        border: 1px solid white;
        border-radius: 10px;
      }
    }
    .jd-desc {
      margin-top: 10px;
      margin-bottom: 20px;
      line-height: 30px;
      color: #666666;
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
      .type-title {
        font-size: 15px;
        font-weight: bold;
        color: #c28a4f;
        white-space: pre-wrap;
      }
      .jd-content {
        font-size: 14px;
        margin-left: 10px;
        white-space: pre-line;
        line-height: 2.5;
      }
    }
    .jd-requirement {
      // border: 1px solid red;
      line-height: 30px;
      color: #666666;
      .type-title {
        font-size: 15px;
        font-weight: bold;
        color: #c28a4f;
      }
      .jd-content {
        // border: 1px solid #ccc;
        font-size: 14px;
        margin-left: 10px;
        margin-bottom: 40px;
        white-space: pre-line;
        line-height: 2.5;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// FzgJoinDetailMobile.vue?15197306